import { useCallback } from "react";
import { RolesPermissionsApi, useAPIAction } from "melco-shared-logic";
import { createBlobServiceWithSas } from "../../plugins/azure/js/azure-storage.blob";

export const useDeleteDownloadSingleFile = (appSettingsResponse: any) => {
  //const { appSettingsResponse } = useAppSettingsContext();
  // const { isLoading, data: appSettingsResponse } = useAppSettings()
  const STORAGE_URI = appSettingsResponse?.download_storage_uri;
  const SAS = appSettingsResponse?.download_storage_sas;
  const CONTAINER = appSettingsResponse?.download_storage_container;

  const BlobService = createBlobServiceWithSas(STORAGE_URI, SAS);

  const [deleteFile] = useAPIAction(
    RolesPermissionsApi,
    async (api, fileName: string) => {
      await BlobService.deleteBlobIfExists(
        CONTAINER,
        fileName,
        function (error: any, result: any) {
          //console.log(error,result);
          if (error) {
            alert(
              "error deleting file. refresh your browser and try again." + error
            );
          } else {
          }
        }
      );

      return {
        successMessages: [{ message: "default" }],
        //data,
      };
    },
    {
      translationPrefix: "downloadfiles.actions.delete",
    }
  );

  return useCallback(
    async (downloadFilePath: string) => {
      const successfullyDeleted: string[] = [];
      try {
        await deleteFile(downloadFilePath);

        console.log(downloadFilePath + " successfully deleted");
        successfullyDeleted.push(downloadFilePath);
      } catch (e) {
        // error handling is already done in useAPIAction
      }

      return successfullyDeleted;
    },
    [deleteFile]
  );
};
